import { ComponentPropsWithoutRef } from 'react';
import { faUserMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Table from 'components/table';

interface ReviewingYourDataTableEmptyProps extends ComponentPropsWithoutRef<'div'> {}
const ReviewingYourDataTableEmpty = (props: ReviewingYourDataTableEmptyProps) => {
    return (
        <Table.Empty {...props}>
            <Table.EmptyIcon>
                <FontAwesomeIcon icon={faUserMagnifyingGlass} />
            </Table.EmptyIcon>
            <Table.EmptyTitle>Reviewing your data...</Table.EmptyTitle>
            <Table.EmptyDescription>
                Come back soon after we've analyzed your contact records.
            </Table.EmptyDescription>
        </Table.Empty>
    );
};

export { ReviewingYourDataTableEmpty };
